import {
	Button,
	ClassNameProps,
	Column,
	compareObjects,
	compareStringsAsc,
	dateTrunc,
	englishCommaJoinStrings,
	filterUniqueObjects,
	If,
	makeClassName,
	RelativeTimestamp,
	Row,
	stringToLocalDate,
	StyleProps,
	TruncatedText,
} from "@hex-insights/core";
import { SlimTimelineItemLoadingPlaceholder } from "../../../../Components/LoadingPlaceholder";
import { TimelineContractListQuery } from "../../../../Utilities";
import { AcademicYearFormat, ContractFormat, ContractLineItemFormat } from "../../../Format";
import { StudentLink } from "../../../Links";
import { ContractModelIcon } from "../../_General/ModelIcons";
import styles from "./styles.module.css";

export type TimelineItemProps = {
	isLoading?: boolean;
	contract: TimelineContractListQuery["contractConnection"]["edges"][0]["node"] | null;
} & Partial<ClassNameProps & StyleProps>;

export function TimelineItem({ isLoading = false, contract, className, style }: TimelineItemProps) {
	if (isLoading && !contract) {
		return <SlimTimelineItemLoadingPlaceholder className={className} style={style} />;
	}

	if (!contract) {
		return null;
	}

	const effectiveDate = contract.effectiveDate
		? stringToLocalDate(contract.effectiveDate, "day")
		: dateTrunc(new Date(), "day");

	const academicYears = filterUniqueObjects(
		contract.academicTerms.map((e) => e.academicYear),
		["id"],
	).sort(compareObjects("name", compareStringsAsc()));

	return (
		<Button
			onClick={() => {}}
			className={makeClassName(styles["timeline-item"], "button--tile", className)}
			style={style}
		>
			<Row justify="spaced-start" align="center" horizontalSpacing="1rem">
				<ContractModelIcon size={24} style={{ padding: "0.5rem" }} />

				<Column justify="spaced-start" verticalSpacing="0.125rem" style={{ width: "100%", minWidth: 0 }}>
					<Row justify="spaced-start">
						<TruncatedText className={styles["timeline-item__main-line"]}>
							<StudentLink instance={contract.student} className="link--primary link--no-text-decoration" /> signed a
							new contract for {englishCommaJoinStrings(academicYears.map((e) => AcademicYearFormat.name(e)))}
						</TruncatedText>

						<RelativeTimestamp value={effectiveDate} precision="day" className="timestamp nowrap" />
					</Row>

					<TruncatedText className={styles["timeline-item__preview-text"]}>
						{ContractFormat.name(contract)}
						<If condition={contract.contractLineItems.length > 0}>
							: {englishCommaJoinStrings(contract.contractLineItems.map((e) => ContractLineItemFormat.name(e)))}
						</If>
					</TruncatedText>
				</Column>
			</Row>
		</Button>
	);
}
